export var DEFAULT_GUTTER = {
  xs: 8,
  sm: 16,
  md: 24
};
export var DASHBOARD_GUTTER = {
  xs: 8,
  sm: 16
};